import { put, takeEvery, takeLatest } from 'redux-saga/effects'
import * as Eff from 'redux-saga/effects' // tslint:disable-line:no-duplicate-imports

import Logger from '@Utils/Logger'

import {
  createOrUpdateExternalTokenSuccess,
  createOrUpdateExternalTokenFailure,
  fetchExternalTokensSuccess,
  fetchExternalTokensFailure,
  deleteExternalTokenSuccess,
  deleteExternalTokenFailure,
} from './actions'

import {
  ExternalTokenActionTypes,
  ICreateOrUpdateExternalTokenPayload,
  ICreateOrUpdateExternalTokenSuccessResponseBody,
  IDeleteExternalTokenPayload,
  IFetchExternalTokensPayload,
  IFetchExternalTokensSuccessResponseBody,
} from './types'

import {
  ISuccessResponse,
  IAction
} from '@Root/types'

import * as API from './api'

const call: any = Eff.call

function* fetchExternalTokensSaga(action: IAction<IFetchExternalTokensPayload>) {
  try {
    const response: ISuccessResponse<IFetchExternalTokensSuccessResponseBody> = yield call(API.fetchExternalTokens, action.payload)
    yield put(fetchExternalTokensSuccess(response.data))
  } catch (e) {
    Logger.error(e, 'Public links could not be loaded')
    yield put(fetchExternalTokensFailure())
  }
}

function* createOrUpdateExternalTokenSaga(action: IAction<ICreateOrUpdateExternalTokenPayload>) {
  try {
    const response: ISuccessResponse<ICreateOrUpdateExternalTokenSuccessResponseBody> = yield call(API.createOrUpdateExternalToken, action.payload)
    yield put(createOrUpdateExternalTokenSuccess(response.data))
  } catch (e) {
    Logger.error(e, 'Link to share could not be created')
    yield put(createOrUpdateExternalTokenFailure())
  }
}

function* deleteExternalTokenSaga(action: IAction<IDeleteExternalTokenPayload>) {
  try {
    yield call(API.deleteExternalToken, action.payload)
    yield put(deleteExternalTokenSuccess(action.payload))
  } catch (e) {
    Logger.error(e, 'Public link could not be removed')
    yield put(deleteExternalTokenFailure())
  }
}

function* externalTokenSagas() {
  yield takeLatest(ExternalTokenActionTypes.FETCH_EXTERNAL_TOKENS, fetchExternalTokensSaga)
  yield takeEvery(ExternalTokenActionTypes.CREATE_OR_UPDATE_EXTERNAL_TOKEN, createOrUpdateExternalTokenSaga)
  yield takeEvery(ExternalTokenActionTypes.DELETE_EXTERNAL_TOKEN, deleteExternalTokenSaga)
}

export default externalTokenSagas
